import React from 'react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import { onScroll } from '@/hooks/paging';
import AuditCards from './AuditCards';
import AuditsPanelContainer from './AuditsPanelContainer';
import AuditEntityFilter from './AuditEntityFilter';
import AuditPanelHeader from './AuditPanelHeader';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const AuditsPanelNarrow = ({
  category,
  code,
  onChange,
  url,
}) => {
  const state = Selectors.useAuditsPanelNarrow({ category, code });
  const fetchData = Events.useFetchAudits(category, { code });

  return (
    <AuditsPanelContainer
      category={category}
      className="aridhia-audits-panel-narrow"
      code={code}
      compact
      onChange={onChange}
      url={url}
    >
      <div className="sticky-panel-header">
        {!code && (
        <AuditEntityFilter
          category={category}
          code={code}
          error={firstErrorMessage(state.readErrors)}
          className="aridhia-list-filter"
          fluid
        />
        )}
        {code && (
        <AuditPanelHeader
          isLoading={state.readStatus === states.PENDING}
          value={state.name}
          category={category}
          code={code}
          className="aridhia-list-filter"
        />
        )}
      </div>
      <AuditCards
        category={category}
        code={code}
        handleScroll={() => onScroll(fetchData, state)}
        items={state.audits}
        itemsPerRow={1}
        readErrors={state.readErrors}
        readStatus={state.readStatus}
      />
    </AuditsPanelContainer>
  );
};

export default AuditsPanelNarrow;
